<nav aria-label="Page navigation" class="mb-3">
    <div class="d-flex justify-content-center align-items-center gap-3 flex-wrap">

        <ul class="pagination mb-0">

            <li class="page-item" [class.disabled]="currentPage === 1">
                <a class="page-link" href="javascript:void(0)" (click)="previousPage()">
                    Previous
                </a>
            </li>

            @for (page of pages; track page) {
            <li class="page-item" [class.active]="page === currentPage">
                <a class="page-link" href="javascript:void(0)" (click)="goToPage(page)">
                    {{ page }}
                </a>
            </li>
            }

            <li class="page-item" [class.disabled]="currentPage === totalPages">
                <a class="page-link" href="javascript:void(0)" (click)="nextPage()">
                    Next
                </a>
            </li>

        </ul>

        <div class="d-flex align-items-center">
            <label class="me-2 mb-0 fw-semibold">Show</label>
            <select class="form-select form-select-sm w-auto" [(ngModel)]="pageSize" (change)="onLimitChange()">
                <option *ngFor="let size of pageSizeOptions" [value]="size">
                    {{ size }}
                </option>
            </select>
            <span class="ms-2">entries</span>
        </div>

    </div>
</nav>